import { FlexBox } from '@cimpress/react-components';
import React, { ReactElement } from 'react';

export const makeFieldLayout = (key: string | ReactElement, component: ReactElement): ReactElement => {
  return <FlexBox alignItems={'start'}>
      <p style={{'width': 200}}><strong>{key}:</strong></p>
      <div style={{flexGrow: 1}}>
        {component}
      </div>
    </FlexBox>;
};

export const checkAllValuesDeep = (obj: Record<string, any>, searchText: string): boolean => {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];

      if (typeof value === 'object' && value !== null) {
        // If the value is an object (and not null), recursively call the function
        const childResult = checkAllValuesDeep(value, searchText);
        if (childResult) {
          return true;
        }
      } else {
        // Otherwise, check if this value matches the search text
        if ((value?.toString() as string).toLocaleLowerCase().includes(searchText)) {
          return true;
        }
      }
    }
  }
  return false;
};
